import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard } from './msal';
import { ASNHistoryComponent } from './pages/asn/asn-history/asn-history.component';
import { ASNPalletTypesComponent } from './pages/asn/asn-pallet-types/asn-pallet-types.component';
import { ASNSummaryComponent } from './pages/asn/asn-summary/asn-summary.component';
import { SummaryDetailsComponent } from './pages/asn/asn-summary/summary-details/summary-details.component';
import { InvoicesComponent } from './pages/document-control/invoices/invoices.component';
import { LogsComponent } from './pages/logs/logs.component';
import { ShipmentsDetailsComponent } from './pages/document-control/shipments/shipments-details/shipments-details.component';
import { ShipmentsComponent } from './pages/document-control/shipments/shipments.component';
import { TransportationEntryDetailsComponent } from './pages/document-control/transportation-entry/transportation-entry-details/transportation-entry-details.component';
import { TransportationEntryComponent } from './pages/document-control/transportation-entry/transportation-entry.component';
import { HomeComponent } from './pages/home/home.component';
import { UnauthorizedComponent } from './pages/unauthorized/unauthorized.component';


const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full', },//,
  { path: 'home', component: HomeComponent, data: { breadcrumb: 'Dashboard' }, canActivate: [MsalGuard] },
  //ASN
  {
    path: '',
    data: { breadcrumb: 'ASN' },
    children: [
      {
        path: 'summary', data: { breadcrumb: '' }, children: [
          { path: '', component: ASNSummaryComponent, data: { breadcrumb: 'Summary' }, canActivate: [MsalGuard] },
          { path: 'summary-details', component: SummaryDetailsComponent, data: { breadcrumb: 'Summary Details' }, canActivate: [MsalGuard] },
        ]
      },
      { path: 'history', component: ASNHistoryComponent, data: { breadcrumb: 'History' }, canActivate: [MsalGuard] },
      { path: 'pallet-type', component: ASNPalletTypesComponent, data: { breadcrumb: 'Pallet Types' }, canActivate: [MsalGuard] },
    ]
  },
  //Document Control
  {
    path: '',
    data: { breadcrumb: 'Document Control' },
    children: [
      { path: 'invoices', component: InvoicesComponent, data: { breadcrumb: 'Invoices' }, canActivate: [MsalGuard] },
      {
        path: 'shipments', data: { breadcrumb: 'Shipments' }, children: [
          { path: '', component: ShipmentsComponent, data: { breadcrumb: '' }, canActivate: [MsalGuard] },
          { path: 'shipment-details', component: ShipmentsDetailsComponent, data: { breadcrumb: 'Details' }, canActivate: [MsalGuard] },
        ]
      },
      {
        path: 'transportation-entry', data: { breadcrumb: 'Transportation Entry' }, children: [
          { path: '', component: TransportationEntryComponent, data: { breadcrumb: '' }, canActivate: [MsalGuard] },
          { path: 'transportation-entry-details', component: TransportationEntryDetailsComponent, data: { breadcrumb: 'Details' }, canActivate: [MsalGuard] },
        ]
      }
    ]
  },
  { path: 'logs', component: LogsComponent, data: { breadcrumb: 'Logs' }, canActivate: [MsalGuard] },
  { path: 'unauthorized', component: UnauthorizedComponent, data: { breadcrumb: '' } }

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
